import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { translate } from '@jsverse/transloco';

import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';
import { Utils } from 'app/utils/utils';

@EnableClassTelemetry()
@Component({
  selector: 'app-impact-table-trend-indicator',
  templateUrl: './impact-table-trend-indicator.component.html',
  styleUrls: ['./impact-table-trend-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ImpactTableTrendIndicatorComponent {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  readonly value = input<number>();
  readonly showTrend = input(false);

  readonly displayValue = computed(() => {
    const v = this.value();
    return v != null ? `${Utils.round(v, 2)}` : translate('widgets.n-a');
  });

  readonly shouldShowTrend = computed(() => this.showTrend() && this.value() != null);

  readonly trendClass = computed(() => {
    const v = this.value();
    if (v > 0.5) {
      return 'trend-indicator--green';
    }
    if (v < -0.5) {
      return 'trend-indicator--red';
    }
    return 'trend-indicator--gray';
  });

  readonly trendIcon = computed(() => {
    const v = this.value();
    if (v > 0.5) {
      return 'trending_up';
    }
    if (v < -0.5) {
      return 'trending_down';
    }
    return 'trending_flat';
  });
}
